<span
  #textElement
  class="truncated-text"
  [class.truncated]="isTruncated()"
  [style.max-width]="maxWidth()"
  [style.-webkit-line-clamp]="maxLines()"
  [matTooltip]="isTruncated() ? text() : ''"
  [matTooltipDisabled]="!isTruncated()"
  [matTooltipPosition]="tooltipPosition()"
  [matTooltipShowDelay]="tooltipDelay()"
>
  {{ text() }}
</span>
